<div class="ubs-card-header" [headerCollapseExpand]="searchExpanded">
    <ubs-title-bread-crumbs #title *ngIf="!searchExpanded"
        class="header-entity-title expanded" 
        [activeBreadCrumb]="activeBreadCrumb"
        (selectedBreadCrumb)="selectBreadCrumb($event)"
        (createView)="loadCreateView($event)"
        (setAction)="editSelected($event)"
        [relations]="relations"
        [selectedValue]="selectedValue">
    </ubs-title-bread-crumbs>
    <ubs-component-header-search #search [state$]="state" (seachResults)="getSearchResults($event)" (selectedValue)="getSelectedValue($event)" (searchExpanded)="toggleBreadCrumbs($event)" class="header-search-container collapsed"></ubs-component-header-search>
    <div class="header-actions">
        <nb-actions size="small">
            <!-- <nb-action icon="list-outline" (click)="loadList()"></nb-action>
            <nb-action icon="plus-circle-outline" (click)="loadCreate()"></nb-action>
            <nb-action *ngIf="hasSelectedValue" icon="edit-outline" (click)="loadEdit()"></nb-action>-->
            <nb-action icon="settings-2-outline" (click)="toggleRightSidebar()"></nb-action>
        </nb-actions>
    </div>
</div>
